function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.091 1C5.51234 1 4.95739 1.22987 4.54822 1.63904C4.13905 2.04821 3.90918 2.60316 3.90918 3.18182V9C3.90918 9.57866 4.13905 10.1336 4.54822 10.5428C4.95739 10.952 5.51234 11.1818 6.091 11.1818C6.66965 11.1818 7.22461 10.952 7.63378 10.5428C8.04295 10.1336 8.27282 9.57866 8.27282 9V3.18182C8.27282 2.60316 8.04295 2.04821 7.63378 1.63904C7.22461 1.22987 6.66965 1 6.091 1V1Z",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1818 7.5459V9.00044C11.1818 10.3506 10.6455 11.6455 9.69073 12.6003C8.736 13.555 7.4411 14.0914 6.09091 14.0914C4.74072 14.0914 3.44582 13.555 2.49109 12.6003C1.53636 11.6455 1 10.3506 1 9.00044V7.5459",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.09082 14.0908V16.9999",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.18262 17H9.0008",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAudio = function SvgAudio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    viewBox: "0 0 12 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio.faa9e85f.svg";
export { ForwardRef as ReactComponent };